import * as React from "react";
import { AnyAction, Dispatch } from "redux";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ERoute from "../../../ERoute";
import RouteHelper from "../../../helpers/RouteHelper";
import { showBoardModal } from "../../../store/modals/actions";
import { Board } from "../../../types";
import BoardsSimplebar from "../../Navigation/SidebarTask/BoardsSimplebar";
import SimplebarWidgetContainer from "./SimplebarWidgetContainer";

const BoardsWidget = () => {
  const dispatch = useDispatch() as Dispatch<AnyAction>;
  const history = useHistory();

  const onBoardItemClick = (board: Board) => {
    history.push(RouteHelper.process(ERoute.PATH_TASKS_BOARD, { id: board.id }));
  };

  const onAddBoardClick = () => {
    dispatch(
      showBoardModal({
        board: {},
        onSubmit: (board) => {
          onBoardItemClick(board);
        },
      })
    );
  };

  return (
    <SimplebarWidgetContainer>
      <BoardsSimplebar
        active={true}
        onItemClick={onBoardItemClick}
        onAddBoardClick={onAddBoardClick}
      />
    </SimplebarWidgetContainer>
  );
};

export default BoardsWidget;
